module.exports = __webpack_public_path__ + "integration-finalytic-logo.png?ec0f9d61e9abf95f5ef9cabceb22c07c";